export const getCustomerPortalLink = (customerId?: number | null) => {
  const pathToCustomerPortal = customerId ? `/portal/${customerId}` : '/portal/'
  return window.origin.includes('localhost')
    ? `http://localhost:10002${pathToCustomerPortal}`
    : window.location.origin + pathToCustomerPortal
}
